<script>
import Video from "../Utils/Video"

export default {
  name: "Lecture",
  components: { Video },
  props: ["lecture"],
  computed: {
    info() { return { 
      title: this.lecture.Title, 
      descr: this.lecture.Description,
      fallback: this.lecture.FallbackMessage
    }},
    video() { return this.lecture.Video },
    track() { return this.lecture.Captions },
  },
}
</script>

<template>
  <div 
    id="lecture"
    aria-label="The lecture quadrant"
    tabindex="0"
  >
    <Video
      v-if="video"
      :info="info"
      :video="video"
      :track="track"
    />
    <div 
      v-else
      class="fallback"
      tabindex="0"
    >
     <p><span> {{ info.fallback }} </span></p>
    </div>
  </div>
</template>

<style scoped>

#lecture {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}



</style>
